<template>
  <Dropdown v-model="show" class="mr-3" class-prop="md:w-112" mobile-title="Add to list" show-header-on-desktop>
    <template #button>
      <a href="#" class="action-btn inline-flex items-center px-2 text-body" :class="btnClass" @click.stop.prevent="toggleFavorite">
        <SpinnerSm v-if="loading" class="text-white" size="14px" />
        <span v-else>
          <svg
            v-if="!saved"
            class="inline-block"
            :width="iconWidth"
            :height="iconHeight"
            viewBox="0 0 18 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.99933 2.28376C8.83377 2.12162 8.67146 1.96725 8.5124 1.82072C8.22835 1.55409 7.92494 1.32468 7.60203 1.13403C7.27683 0.933687 6.92433 0.77881 6.54646 0.668416C6.15347 0.553606 5.71948 0.5 5.25 0.5C4.59625 0.5 3.97605 0.624713 3.39465 0.877101C2.82382 1.1249 2.3209 1.46403 1.88994 1.89445C1.45697 2.32164 1.11685 2.82602 0.868825 3.4025L0.867873 3.40474C0.621808 3.98443 0.5 4.60033 0.5 5.24763C0.5 5.87955 0.619249 6.48803 0.857707 7.06931L0.85936 7.07324C1.103 7.65302 1.44682 8.16575 1.88894 8.60762L9 15.7065L16.1113 8.60742C16.5537 8.16519 16.8951 7.65198 17.1337 7.07126C17.3778 6.48968 17.5 5.88049 17.5 5.24763C17.5 4.59972 17.3753 3.98338 17.1238 3.4036C16.881 2.82661 16.5432 2.32183 16.1101 1.89445C15.6791 1.46403 15.1762 1.1249 14.6054 0.877101C14.0239 0.624713 13.4038 0.5 12.75 0.5C12.2805 0.5 11.8465 0.553606 11.4535 0.668416C11.075 0.779004 10.72 0.934025 10.3902 1.13405C10.0727 1.32456 9.76988 1.55348 9.48156 1.81905L9.47796 1.82243C9.32262 1.96837 9.16307 2.12216 8.99933 2.28376ZM9.35663 4.7548C9.64621 4.46012 9.92297 4.17036 10.1869 3.88553C10.4357 3.6173 10.6923 3.38054 10.9563 3.17424C11.2054 2.97958 11.4768 2.82367 11.7716 2.70581L11.7776 2.70328C12.0449 2.59234 12.3658 2.53067 12.75 2.53067C13.1403 2.53067 13.4949 2.60213 13.8195 2.74052L13.8269 2.74354C14.1634 2.88072 14.4505 3.07083 14.6934 3.31355L14.6998 3.31975C14.9459 3.55713 15.1399 3.841 15.2814 4.17683L15.2823 4.17902C15.4208 4.5033 15.4922 4.85766 15.4922 5.24763C15.4922 5.61564 15.4238 5.96524 15.2871 6.30019C15.1512 6.6331 14.9544 6.92871 14.6934 7.18957L9 12.8798L3.30658 7.18957C3.04515 6.92829 2.84523 6.63179 2.70405 6.29758C2.56806 5.96342 2.5 5.61468 2.5 5.24763C2.5 4.86471 2.57074 4.51019 2.70971 4.17938C2.85759 3.8398 3.05418 3.55014 3.29877 3.30569C3.54883 3.05576 3.84068 2.86008 4.17832 2.718L4.18342 2.71578C4.51404 2.57231 4.8679 2.49944 5.25 2.49944C5.61979 2.49944 5.93375 2.56239 6.20072 2.67732L6.20326 2.6784C6.50575 2.80666 6.78133 2.97077 7.0315 3.17079L7.03495 3.1735C7.30495 3.38552 7.56441 3.62523 7.81315 3.89333C8.08313 4.18432 8.36093 4.47255 8.64655 4.758L9.0032 5.11446L9.35663 4.7548Z" :fill="color" />
          </svg>
          <svg
            v-else
            class="inline-block"
            :width="iconWidth"
            :height="iconHeight"
            viewBox="0 0 17 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.49933 1.78368C8.33377 1.62153 8.17146 1.46717 8.01241 1.32064C7.72835 1.05401 7.42494 0.8246 7.10203 0.633953C6.77683 0.433607 6.42433 0.278729 6.04646 0.168336C5.65347 0.0535256 5.21948 -8.01086e-05 4.75 -8.01086e-05C4.09625 -8.01086e-05 3.47605 0.124633 2.89465 0.377021C2.32382 0.624818 1.8209 0.963953 1.38994 1.39437C0.956975 1.82156 0.61685 2.32594 0.368825 2.90242L0.367873 2.90466C0.121808 3.48435 0 4.10024 0 4.74755C0 5.37946 0.119249 5.98795 0.357707 6.56923L0.35936 6.57316C0.603001 7.15293 0.94682 7.66567 1.38894 8.10754L8.5 15.2064L15.6113 8.10734C16.0537 7.66511 16.3951 7.1519 16.6337 6.57118C16.8778 5.9896 17 5.38041 17 4.74755C17 4.09964 16.8753 3.4833 16.6238 2.90352C16.381 2.32653 16.0432 1.82175 15.6101 1.39437C15.1791 0.963953 14.6762 0.624818 14.1054 0.377021C13.5239 0.124633 12.9038 -8.01086e-05 12.25 -8.01086e-05C11.7805 -8.01086e-05 11.3465 0.0535256 10.9535 0.168336C10.575 0.278923 10.22 0.433945 9.89017 0.63397C9.57267 0.824479 9.26988 1.0534 8.98156 1.31897L8.97796 1.32235C8.82262 1.46829 8.66307 1.62208 8.49933 1.78368Z" :fill="color" />
          </svg>
        </span>
        <span v-if="text" class="ml-3 text-lg">{{ text }}</span>
      </a>
    </template>

    <div>
      <div v-if="lodingLists" class="px-4 py-2">
        <div class="h-20 spinner" />
      </div>
      <div v-else class="overflow-y-auto md:max-h-100">
        <div class="flex items-center px-4 py-2">
          <div class="mr-4">
            <div role="button" style="width: 89px; height: 89px;" class="flex items-center justify-center rounded-lg bg-gray-light" @click="createList">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13.5 10.5V0H10.5L10.5 10.5L0 10.5V13.5L10.5 13.5L10.5 24H13.5V13.5L24 13.5V10.5H13.5Z" fill="#4348DB" />
              </svg>
            </div>
          </div>
          <div class="flex-1">
            <input
              v-model="form.name"
              :disabled="creatingList"
              type="text"
              class="w-full text-xl font-bold leading-loose placeholder:text-gray-mid2 focus:outline-none"
              placeholder="Name the list"
              @keyup.enter="createList"
            >
          </div>
        </div>
        <div
          v-for="list in lists"
          :key="list.id"
          class="flex cursor-pointer items-center px-4 py-2"
          :class="{ 'bg-blue-highlight': selectedList && selectedList.id === list.id }"
          role="button"
          @click="selectedList = list"
        >
          <div class="mr-4">
            <div style="width: 89px; height: 89px;" class="rounded-lg bg-gray-light" />
          </div>
          <div class="flex-1">
            <div class="mb-2 text-xl font-bold text-slate">
              {{ list.name }}
            </div>
            <div>
              {{ list.count }} {{ $f.pluralize('venue', list.count) }} saved
            </div>
          </div>
        </div>
      </div>
    </div>

    <template #footer>
      <div class="text-right">
        <button
          class="letter-sp15 h-10 rounded-md bg-blue px-4 text-sm uppercase leading-10 text-white hover:bg-blue-dark md:px-8"
          :class="{ 'opacity-75': !selectedList && !form.name, 'cursor-not-allowed': !selectedList && !form.name }"
          :disabled="!selectedList && !form.name"
          @click="favorite"
        >
          Save
          <span v-if="savingVenue" class="-mr-3 -mt-1 inline-block w-8 align-middle spinner-sm" />
        </button>
      </div>
    </template>
  </Dropdown>
</template>

<script>
import { mapState } from 'pinia'
import { addDoc, collection, deleteDoc, doc, getDocs, query, where } from 'firebase/firestore'
import Dropdown from '~/components/shared/Dropdown'
import { initFirebase } from '~/utils/firebase'
import SpinnerSm from '~/components/shared/SpinnerSm'
import { useAuthStore } from '~/stores/auth'

export default {
  components: { SpinnerSm, Dropdown },

  props: {
    venue: { type: Object, required: true },
    color: { type: String, default: '#333333' },
    text: { type: String, default: '' },
    iconWidth: { type: Number, default: 18 },
    iconHeight: { type: Number, default: 16 },
    btnClass: { type: [String, Array, Object], default: '' },
  },

  data: () => ({
    toggleOnAuth: false,
    saved: false,
    savedDocId: null,
    show: false,
    lists: [],
    selectedList: null,
    lodingLists: false,
    savingVenue: false,
    form: {
      name: '',
    },

    creatingList: false,
    fireDb: null,
  }),

  computed: {
    ...mapState(useAuthStore, ['user', 'loading']),
  },

  watch: {
    async user (val) {
      await this.initDb()
      if (val && this.toggleOnAuth) {
        await this.toggleFavorite()
        this.toggleOnAuth = false
      }
      if (val) {
        await this.checkIfFavorited()
      }
    },

    async show (val) {
      await this.initDb()
      if (val) { await this.loadLists() }
    },
  },

  async mounted () {
    if (! this.user) { return }
    await this.initDb()
    await this.checkIfFavorited()
  },

  methods: {
    async initDb () {
      // eslint-disable-next-line no-unused-vars
      const [_, db] = await initFirebase()
      this.fireDb = db
    },

    async checkIfFavorited () {
      const q = query(collection(this.fireDb, 'savedVenues'),
        where('userId', '==', this.user.uid),
        where('venueId', '==', this.venue.id),
      )
      const res = await getDocs(q)

      this.savedDocId = res.docs.length ? res.docs[0].id : null
      this.saved = ! res.empty
    },

    async loadLists () {
      this.lodingLists = true

      const q = query(collection(this.fireDb, 'saveLists'),
        where('userId', '==', this.user.uid),
      )
      const res = await getDocs(q)

      this.lists = await Promise.all(res.docs.map(async (d) => {
        const q = query(collection(this.fireDb, 'savedVenues'),
          where('userId', '==', this.user.uid),
          where('listId', '==', d.id),
        )
        const count = await getDocs(q)

        return { id: d.id, ...d.data(), count: count.docs.length }
      }))
      this.lodingLists = false
    },

    async createList () {
      if (! this.form.name) { return }
      this.creatingList = true

      const res = await addDoc(collection(this.fireDb, 'saveLists'), {
        userId: this.user.uid,
        name: this.form.name,
      })

      this.lists.unshift({ id: res.id, userId: this.user.uid, name: this.form.name, count: 0 })
      this.form.name = ''
      this.creatingList = false
      return this.lists[0]
    },

    async toggleFavorite () {
      if (! this.user) {
        this.toggleOnAuth = true
        this.$eventHub.emit('show-auth')
        return
      }

      if (this.saved) {
        await this.unfavorite()
      } else {
        this.show = true
      }
    },

    async favorite () {
      this.savingVenue = true
      if (! this.selectedList && this.form.name) {
        this.selectedList = await this.createList()
      }

      const res = await addDoc(collection(this.fireDb, 'savedVenues'), {
        venueId: this.venue.id,
        userId: this.user.uid,
        listId: this.selectedList.id,
      })

      this.saved = true
      this.savedDocId = res.id
      this.savingVenue = false
      this.show = false
    },

    async unfavorite () {
      if (! this.savedDocId) { return }
      await deleteDoc(doc(this.fireDb, 'savedVenues', this.savedDocId))
      this.saved = false
      this.savedDocId = null
    },
  },
}
</script>

<style lang="scss" scoped>
:deep() {
  .dropdown-content {
    @apply p-0;
  }
  .dropdown-footer {
    @media (min-width: 768px) {
      @apply mt-0;
    }
  }
}
</style>
